module.exports = __webpack_public_path__ + "img/swine-blue.743bba82.png";